import gql from 'graphql-tag';

const UPDATE_CUSTOMER_MUTATION = gql`
  mutation(
      $customerId: Int!,
      $maritalStateId: Int,
      $startDateCareer: Date,
      $totalGrossRemuneration2020: Decimal
      $monthsIndependentBefore2021: Int) {  
    updateCustomer(
      customerId: $customerId,
      maritalStateId: $maritalStateId,
      startDateCareer: $startDateCareer,
      totalGrossRemuneration2020: $totalGrossRemuneration2020
      monthsIndependentBefore2021: $monthsIndependentBefore2021
    ){
      customerId
      firstName
      lastName   
      bus
      birthDate
      street
      number
      postalCode
      totalGrossRemuneration2020
      monthsIndependentBefore2021
      legalPensionAge
      city
      startDateCareer    
      maritalState {
        maritalStateId
        name
      }
      language {
        code
      }
    }
  }
`;

export default UPDATE_CUSTOMER_MUTATION;
